import moment from "moment";

export const DateFormat = (dateValue, dateFormat = 'DD-MM-YYYY hh:mm A') => {
    if(dateValue){
        //return moment(dateValue).format(dateFormat);
        return moment.utc(dateValue).format(dateFormat);
    }else{
        return '';
    }
}

export const ConvertUtcToLocal = (
  utcDateValue,
  dateFormat = "DD-MM-YYYY hh:mm A"
) => {
  if (!utcDateValue) return "";

  // Convert from UTC to local time
  return moment.utc(utcDateValue).local().format(dateFormat);
};

export const ConvertLocalToUtc = (
  dateValue,
  dateFormat = "YYYY-MM-DD HH:mm:ss"
) => {
  if (dateValue) {
    if (dateValue.match(/\d+/g).length === 3) {
      let current_time = moment().format("HH:mm:ss");
      dateValue = moment(`${dateValue + " " + current_time}`).toDate();
    } else {
      //dateValue = new  Date(dateValue);
      dateValue = moment(`${dateValue}`).toDate();
    }
    let utcdate = moment.utc(moment(dateValue).utc()).format(dateFormat);
    return utcdate;
  } else {
    return "";
  }
};